import type { UserSearchListResultApiResponse, UserSearchSaveResultApiResponse } from "../types.ts"

function createApiUrlForUserSearch() {
    return `${SiteInfo.yiiLadiesUrl}/api/user-suche`
}

export async function fetchUserSearchResults(): Promise<UserSearchListResultApiResponse> {
    return fetch(createApiUrlForUserSearch(), {
        credentials: "include",
    }).then(handleResponse)
}

export async function postNewUserSearch(userSearchData: FormData): Promise<UserSearchSaveResultApiResponse> {
    return fetch(`${SiteInfo.yiiLadiesUrl}/api/user-suche?catalog=1`, {
        method: "POST",
        credentials: "include",
        body: userSearchData,
    }).then(handleResponse)
}

async function handleResponse(response: Response) {
    if (!response.ok) {
        throw Error(JSON.stringify(await response.json()))
    }
    return response.json()
}
